export const MAX_DESCRIPTION_LENGTH = 150;
export const MAX_VALUE_DIGITS = 10;
